import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Categories from './pages/Categories';
import ImportData from './pages/ImportData';
import Budget from './pages/Budget';
import Insights from './pages/Insights';
import Settings from './pages/Settings';
import Pricing from './pages/Pricing';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/AdminDashboard';
import Layout from './components/Layout';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={!token ? <LandingPage /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/login"
            element={!token ? <Login onLogin={handleLogin} /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/dashboard"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Dashboard token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/transactions"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Transactions token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/categories"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Categories token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/import"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <ImportData token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/budget"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Budget token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/insights"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Insights token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/settings"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <Settings token={token} onLogout={handleLogout} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/admin"
            element={
              token ? (
                <Layout user={user} onLogout={handleLogout}>
                  <AdminDashboard token={token} />
                </Layout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/pricing"
            element={<Pricing token={token} />}
          />
          <Route
            path="/subscription/success"
            element={
              token ? (
                <SubscriptionSuccess token={token} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/privacy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/terms"
            element={<TermsOfService />}
          />
          <Route
            path="/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="/reset-password"
            element={<ResetPassword />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
      <InstallPrompt />
    </div>
  );
}

export default App;
